export var ACTION;
(function (ACTION) {
    ACTION["TEST_ACTION"] = "TEST_ACTION";
    ACTION["NAV_TO_BANK_ADD"] = "NAV_TO_BANK_ADD";
    ACTION["GO_BACK"] = "GO_BACK";
    ACTION["TOGGLE_CTA"] = "TOGGLE_CTA";
    ACTION["NAVIGATION_NEXT"] = "NAVIGATION_NEXT";
    ACTION["CALL_WEB_API"] = "CALL_WEB_API";
    ACTION["HANDLE_ANDROID_CALLBACK"] = "HANDLE_ANDROID_CALLBACK";
    ACTION["CLOSE_ERROR_MODAL"] = "CLOSE_ERROR_MODAL";
    ACTION["START_KFS_GENERATION"] = "START_KFS_GENERATION";
})(ACTION || (ACTION = {}));
